import "./App.css";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { Provider, useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import store from "./store/store";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import Slider from "./components/Slider";
import DepositWithdrawModal from "./components/Modals/DepositWithdrawModal";
import ContactModal from "./components/Modals/ContactModal";
import LoginModal from "./components/Modals/LoginModal";
import Footer from "./components/Footer";
import PageContent from "./components/PageContent";
import { useEffect, useRef, useState } from "react";
import {
  getWebsiteSetting,
  getUsersByID,
  getPlayerBalance,
  getPlayerCash,
  getAllRanking,
} from "./store/slices/user";
import useAuth from "./hooks/useAuth";
import { Icon } from "@iconify/react";
import SocketProvider from "./SocketContext";
import socketManager from "./utils/socket";

function AppLayout() {
  const location = useLocation();
  const [isDepositModalOpen, setIsDepositModalOpen] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  // Socket notification states
  const [open2, setOpen2] = useState(false);
  const [openSuccessDeposit, setOpenSuccessDeposit] = useState(false);
  const [lastPong, setLastPong] = useState(null);
  const [lastPong2, setLastPong2] = useState(null);
  const sidebarRef = useRef(null);
  const dispatch = useDispatch();
  const singleUsers = useSelector((state) => state.user.singleUsers);
  const websiteSetting = useSelector((state) => state.user.websiteSetting);
  const { user, isAuthenticated } = useAuth();
  const userId = user?.id;
  const currentUser = Array.isArray(singleUsers)
    ? singleUsers[0]
    : singleUsers?.data?.[0];
  const withdrawConditionDetail = currentUser?.withdrawConditionDetail;
  const promotionDetail = currentUser?.PromotionDetail;
  const promotionStatus = currentUser?.PromotionStatus;
  const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || "").replace(
    /\/$/,
    "",
  );
  const backgroundPath = Array.isArray(websiteSetting)
    ? websiteSetting[0]?.webBackgroundUrl
    : websiteSetting?.data?.[0]?.webBackgroundUrl ||
      websiteSetting?.webBackgroundUrl;
  const backgroundUrl = backgroundPath
    ? backgroundPath.startsWith("http")
      ? backgroundPath
      : `${apiBaseUrl}${
          backgroundPath.startsWith("/") ? "" : "/"
        }${backgroundPath}`
    : "";
  const hideSidebar = location.pathname === "/menu";
  const isMenuPage = location.pathname === "/menu";

  // Redesigned notification bars for turn/promo
  const renderTurnPromo = () => {
    const isPromoActive = promotionStatus === "ACTIVE";
    const barBase = {
      borderRadius: 14,
      padding: "14px 18px",
      margin: "10px auto",
      width: isMenuPage ? "min(70%, 820px)" : "70%",
      maxWidth: isMenuPage ? "820px" : "70%",
      display: "flex",
      alignItems: "center",
      gap: 14,
      backdropFilter: "blur(12px)",
      border: "1px solid",
      position: "relative",
      overflow: "hidden",
    };
    return (
      <>
        {withdrawConditionDetail && (
          <div
            style={{
              ...barBase,
              background:
                "linear-gradient(135deg, rgba(239,68,68,0.18) 0%, rgba(185,28,28,0.12) 100%)",
              borderColor: "rgba(239,68,68,0.3)",
              boxShadow: "0 4px 20px rgba(239,68,68,0.12)",
            }}
          >
            <div
              style={{
                width: 44,
                height: 44,
                borderRadius: 12,
                background: "linear-gradient(135deg, #ef4444, #b91c1c)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                boxShadow: "0 4px 12px rgba(239,68,68,0.35)",
              }}
            >
              <Icon icon="solar:shield-warning-bold" width={24} color="#fff" />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                style={{
                  color: "#fca5a5",
                  fontSize: 11,
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: 0.8,
                  marginBottom: 2,
                }}
              >
                ⚠ ติดเงื่อนไขถอน
              </div>
              <div
                style={{
                  color: "#fff",
                  fontSize: 14,
                  fontWeight: 600,
                  lineHeight: 1.4,
                }}
              >
                กรุณาทำเทิร์นให้ครบก่อนถอนเงิน
              </div>
              <div
                style={{
                  color: "rgba(255,255,255,0.6)",
                  fontSize: 12,
                  marginTop: 2,
                }}
              >
                {withdrawConditionDetail}
              </div>
            </div>
          </div>
        )}

        {promotionDetail && (
          <div
            style={{
              ...barBase,
              background: isPromoActive
                ? "linear-gradient(135deg, rgba(245,158,11,0.18) 0%, rgba(217,119,6,0.12) 100%)"
                : "linear-gradient(135deg, rgba(100,100,100,0.15) 0%, rgba(60,60,60,0.1) 100%)",
              borderColor: isPromoActive
                ? "rgba(245,158,11,0.3)"
                : "rgba(160,160,160,0.2)",
              boxShadow: isPromoActive
                ? "0 4px 20px rgba(245,158,11,0.12)"
                : "0 4px 20px rgba(0,0,0,0.1)",
            }}
          >
            <div
              style={{
                width: 44,
                height: 44,
                borderRadius: 12,
                background: isPromoActive
                  ? "linear-gradient(135deg, #f59e0b, #d97706)"
                  : "linear-gradient(135deg, #737373, #525252)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                boxShadow: isPromoActive
                  ? "0 4px 12px rgba(245,158,11,0.35)"
                  : "0 4px 12px rgba(0,0,0,0.2)",
              }}
            >
              <Icon
                icon={
                  isPromoActive ? "solar:gift-bold" : "solar:gift-line-duotone"
                }
                width={24}
                color="#fff"
              />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                style={{
                  color: isPromoActive ? "#fcd34d" : "rgba(255,255,255,0.5)",
                  fontSize: 11,
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: 0.8,
                  marginBottom: 2,
                }}
              >
                {isPromoActive ? "🎁 กำลังใช้โปรโมชั่น" : "📋 เลือกโปรแล้ว"}
              </div>
              <div
                style={{
                  color: "#fff",
                  fontSize: 14,
                  fontWeight: 600,
                  lineHeight: 1.4,
                }}
              >
                {promotionDetail}
              </div>
              {!isPromoActive && (
                <div
                  style={{
                    color: "rgba(255,255,255,0.55)",
                    fontSize: 12,
                    marginTop: 2,
                  }}
                >
                  ฝากเงินเพื่อเปิดใช้งานโปรโมชั่นนี้
                </div>
              )}
            </div>
          </div>
        )}
      </>
    );
  };

  useEffect(() => {
    dispatch(getWebsiteSetting());
  }, [dispatch]);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getAllRanking());
    }
  }, [dispatch, isAuthenticated]);

  useEffect(() => {
    const body = document.body;
    if (backgroundUrl) {
      body.style.setProperty("--app-bg-image", `url("${backgroundUrl}")`);
    } else {
      body.style.setProperty("--app-bg-image", "none");
    }
  }, [backgroundUrl]);

  // fetch latest singleUsers by current user id
  useEffect(() => {
    if (userId) {
      dispatch(getUsersByID(userId));
    }
  }, [userId, dispatch]);

  // Replace previous socket effect with instance-based binding
  useEffect(() => {
    const socket = socketManager;

    if (!socket || !user || !user.id) return;

    const baseSocket = socket.connect();
    const userChannel = String(user.id);
    const depositName = `deposit-${user.id}`;
    const depositPaymentName = `depositpayment-${user.id}`;

    try {
      baseSocket.emit("join-user-room", user.id);
    } catch {}

    const onNotApprove = (res) => {
      setLastPong(`ไม่อนุมัติถอนเงิน! ${res}`);
      setOpen2(true);
      setTimeout(() => {
        dispatch(getPlayerBalance(user));
        setOpen2(false);
      }, 6000);
    };

    const onDeposit = (res) => {
      setLastPong2(`ฝากเงินจำนวน ${res} บาท สำเร็จ!`);
      setOpenSuccessDeposit(true);
      setTimeout(() => {
        dispatch(getPlayerBalance(user));
        dispatch(getUsersByID(user));
        dispatch(getPlayerCash(user));
        setOpenSuccessDeposit(false);
      }, 6000);
    };

    const onDepositPayment = (res) => {
      console.log("Received event:", depositPaymentName, "with data:", res);
      setLastPong2(`ฝากเงินจำนวน ${res} บาท สำเร็จ!`);
      setOpenSuccessDeposit(true);
      setTimeout(() => {
        dispatch(getPlayerBalance(user));
        dispatch(getUsersByID(user));
        dispatch(getPlayerCash(user));
        setOpenSuccessDeposit(false);

        const depositModal = document.querySelector(".deposit-modal");
        if (depositModal) {
          const depositComponent =
            depositModal.__reactFiber$?.return?.stateNode;
          if (depositComponent?.handleClose) {
            depositComponent.handleClose();
          }
        }
      }, 6000);
    };

    baseSocket.on(userChannel, onNotApprove);
    baseSocket.on(depositName, onDeposit);
    baseSocket.on(depositPaymentName, onDepositPayment);

    return () => {
      try {
        baseSocket.off(userChannel, onNotApprove);
        baseSocket.off(depositName, onDeposit);
        baseSocket.off(depositPaymentName, onDepositPayment);
      } catch (e) {
        // ignore
      }
    };
  }, [dispatch, user]);

  // Listen for global user updates (fallback)
  useEffect(() => {
    const onUserUpdate = (e) => {
      if (e?.detail?.userId && e.detail.userId === userId) {
        dispatch(getUsersByID(userId));
      }
    };
    window.addEventListener("app:userUpdate", onUserUpdate);
    return () => window.removeEventListener("app:userUpdate", onUserUpdate);
  }, [dispatch, userId]);

  const isLoginPage = location.pathname === "/login";

  if (isLoginPage) {
    return (
      <div className="App">
        <PageContent />
      </div>
    );
  }

  return (
    <div className="App">
      <div className="App-header-bg sticky-header">
        <Header
          onLoginClick={() => setIsLoginModalOpen(true)}
          onContactClick={() => setIsContactModalOpen(true)}
        />
      </div>

      {/* Custom Socket Alerts (no MUI) */}
      {open2 && (
        <div className="app-alert-wrapper" style={{ top: 80 }}>
          <div className="app-alert app-alert--warning">
            <Icon icon="mdi:alert" width={22} height={22} />
            <span style={{ color: "#000" }}>{lastPong}</span>
            <button
              className="app-alert__close"
              aria-label="close"
              onClick={() => setOpen2(false)}
            >
              ×
            </button>
          </div>
        </div>
      )}
      {openSuccessDeposit && (
        <div className="app-alert-wrapper" style={{ top: 120 }}>
          <div className="app-alert app-alert--success">
            <Icon icon="mdi:check-circle" width={22} height={22} />
            <span style={{ color: "#000" }}>{lastPong2}</span>
            <button
              className="app-alert__close"
              aria-label="close"
              onClick={() => setOpenSuccessDeposit(false)}
            >
              ×
            </button>
          </div>
        </div>
      )}
      <div className="App-content">
        {!hideSidebar && (
          <div ref={sidebarRef} className="desktop-sidebar">
            <Sidebar isMobileMenuOpen={false} onMobileMenuToggle={() => {}} />
          </div>
        )}
        <main
          className={`App-main${location.pathname === "/menu" ? " App-main--no-margin" : ""}`}
        >
          {!hideSidebar && <Slider />}
          <div className="mobile-content">
            {!hideSidebar && (
              <div
                ref={sidebarRef}
                className="mobile-sidebar"
                style={{ position: "sticky", top: 0 }}
              >
                <Sidebar
                  isMobileMenuOpen={false}
                  onMobileMenuToggle={() => {}}
                />
              </div>
            )}
            <div className="mobile-right-content">
              {!isMenuPage && (
                <div className="mobile-marquee">{renderTurnPromo()}</div>
              )}
              <div className="mobile-page-content">
                <PageContent />
              </div>
            </div>
          </div>
          {/* Turn and Promotion Details - Desktop only */}
          {!isMenuPage && (
            <div className="desktop-marquee">{renderTurnPromo()}</div>
          )}

          <div className="desktop-page-content">
            <PageContent />
          </div>
        </main>
      </div>
      <Footer
        onDepositClick={() => setIsDepositModalOpen(true)}
        onContactClick={() => setIsContactModalOpen(true)}
      />
      {/* Modals */}
      <DepositWithdrawModal
        isOpen={isDepositModalOpen}
        onClose={() => setIsDepositModalOpen(false)}
      />
      <ContactModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
      <LoginModal
        isOpen={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
      />
    </div>
  );
}

function App() {
  return (
    <Provider store={store}>
      <SocketProvider>
        <Router>
          <AppLayout />
        </Router>
      </SocketProvider>
    </Provider>
  );
}

export default App;
